import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IFirebaseMaintenanceData } from '@interfaces/maintenance';
import { getMaintenanceInfo } from '@services/maintenance.service';

export const fetchMaintenanceInfo = createAsyncThunk('maintenance/fetchMaintenanceInfo', async () => {
	const response = await getMaintenanceInfo();
	return response;
});

export interface MaintenanceState {
	firebaseMaintenanceData: IFirebaseMaintenanceData;
	isLoading: boolean;
}

const initialState: MaintenanceState = {
	firebaseMaintenanceData: {
		'customerApp-android': { isDown: false, deeplink: '' },
		'customerApp-ios': { isDown: false, deeplink: '' },
		blockchain: { isDown: false, deeplink: '' },
		cardPayment: {
			AU: { isDown: false, deeplink: '' },
			SG: { isDown: false, deeplink: '' },
		},
		voucher: { isDown: false, deeplink: '' },
		privilege: { isDown: false, deeplink: '' },
	},
	isLoading: false,
};

const maintenanceSlice = createSlice({
	name: 'maintenance',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(fetchMaintenanceInfo.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(fetchMaintenanceInfo.fulfilled, (state, { payload }) => {
				state.isLoading = false;
				state.firebaseMaintenanceData = payload.data ?? initialState.firebaseMaintenanceData;
			})
			.addCase(fetchMaintenanceInfo.rejected, (state) => {
				state.isLoading = false;
			});
	},
});

export const maintenanceReducer = maintenanceSlice.reducer;
export default maintenanceSlice;
